if (!customElements.get('login-form')) {
  class Login extends HTMLElement {
    constructor() {
      super();
      this.accountUrl = this.dataset.accountUrl;
    }

    connectedCallback() {
      this.addDelegatedClickListeners();
    }

    addDelegatedClickListeners() {
      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-account-action]');
        if (!clickedElement) return;
        
        const { 
          accountAction: action,
          accountTarget
        } = clickedElement.dataset;

        switch (action) {
          case 'toggle-section':  
            [...this.querySelectorAll('[data-account-action]')].forEach(btn => {
              btn.dataset.accountTarget === accountTarget ? btn.setAttribute('disabled', true) : btn.removeAttribute('disabled', true); 
            });
            [...this.querySelectorAll('[data-account-section]')].forEach(section => {
              section.dataset.accountSection === accountTarget ? section.classList.remove('hidden') : section.classList.add('hidden'); 
            });
            trapFocusInDialog(this);  
          break;
          case 'open-reset-password-section':
            this.querySelector('[data-reset-password-section]')?.classList.remove('hidden');
          break;
          case 'close-reset-password-section': 
            this.querySelector('[data-reset-password-section]')?.classList.add('hidden');
          break;
          default: break;
        }
      })
    }
  }

  customElements.define('login-form', Login);
}